import { LevelPrerequisiteComponent } from "./level-info/level-prerequisite/level-prerequisitecomponent";
import { NgModule } from "@angular/core";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig } from "ng2-currency-mask/src/currency-mask.config";

import { sharedModule } from "src/app/shared/shared.module";
import { CourseComponent } from "./course/course.component";
import { TermInfoComponent } from "./term-info/term-info.component";
import { CourseTypeComponent } from "./course-type/course-type.component";
import { AddCourseComponent } from "./course/add-course/add-course.component";
import { CourseListComponent } from "./course/course-list/course-list.component";
import { CoursePatternComponent } from "./course-pattern/course-pattern.component";
import { TermInfoListComponent } from "./term-info/term-info-list/term-info-list.component";
import { EducationPackageComponent } from "./education-package/education-package.component";
import { PackageListComponent } from "./education-package/package-list/package-list.component";
import { AddCourseEntryComponent } from "./course/add-course-entry/add-course-entry.component";
import { TermInfoEntryComponent } from "./term-info/term-info-entry/term-info-entry.component";
import { AddTeacherEntryComponent } from "./course/add-teacher-entry/add-teacher-entry.component";
import { CourseTypeListComponent } from "./course-type/course-type-list/course-type-list.component";
import { PlacementTimeSheetComponent } from "./placement-time-sheet/placement-time-sheet.component";
import { CourseTypeEntryComponent } from "./course-type/course-type-entry/course-type-entry.component";
import { TimeSheetListComponent } from "./placement-time-sheet/time-sheet-list/time-sheet-list.component";
import { TimeSheetEntryComponent } from "./placement-time-sheet/time-sheet-entry/time-sheet-entry.component";
import { AddPackageEntryComponent } from "./education-package/add-package-entry/add-package-entry.component";
import { CoursePatternListComponent } from "./course-pattern/course-pattern-list/course-pattern-list.component";
import { CoursePatternEntryComponent } from "./course-pattern/course-pattern-entry/course-pattern-entry.component";
import { PlacementTypeEntryComponent } from "./education-package/placement-type-entry/placement-type-entry.component";
import { CourseHistoryComponent } from "./course-history/course-history.component";
import { CourseHistoryEntryComponent } from "./course-history/course-history-entry/course-history-entry.component";
import { CourseHistoryListComponent } from "./course-history/course-history-list/course-history-list.component";
import { ParrentTermComponent } from "./parrent-term/parrent-term.component";
import { ParentTermListComponent } from "./parrent-term/parent-term-list/parent-term-list.component";
import { ParentTermEntryComponent } from "./parrent-term/parent-term-entry/parent-term-entry.component";
import { LevelInfoComponent } from "./level-info/level-info.component";
import { LevelInfoListComponent } from "./level-info/level-info-list/level-info-list.component";
import { LevelInfoEntryComponent } from "./level-info/level-info-entry/level-info-entry.component";
import { LevelPrerequisiteListComponent } from "./level-info/level-prerequisite/level-prerequisite-list/level-prerequisite-list.component";
import { LevelPrerequisiteEntryComponent } from "./level-info/level-prerequisite/level-prerequisite-entry/level-prerequisite-entry.component";
import { LevelPriceComponent } from "./level-info/level-prerequisite/level-price/level-price.component";
import { LevelPriceEntryComponent } from "./level-info/level-prerequisite/level-price/level-price-entry/level-price-entry.component";
import { LevelPriceListComponent } from "./level-info/level-prerequisite/level-price/level-price-list/level-price-list.component";
import { AlertDialogComponent } from "src/app/components/alert-dialog/alert-dialog.component";
import { StaffComponent } from './staff/staff.component';
import { StaffListComponent } from './staff/staff-list/staff-list.component';
import { TeacherToLvlEntryComponent } from './staff/teacher-to-lvl-entry/teacher-to-lvl-entry.component';
import { CourseSessionsCheckoutComponent } from './course/course-sessions-checkout/course-sessions-checkout.component';
import { PackageEducationBranchComponent } from './education-package/package-education-branch/package-education-branch.component';
import { AddLevelToPackageComponent } from './education-package/add-level-to-package/add-level-to-package.component';
import { RegisterStudentCourseComponent } from './course/register-student-course/register-student-course.component';
import { EditCourseEntryComponent } from './course/edit-course-entry/edit-course-entry.component';
import { CompanyRegistrationComponent } from './company-registration/company-registration.component';
import { CompanyRegistrationListComponent } from './company-registration/company-registration-list/company-registration-list.component';
import { CompanyRegistrationEntryComponent } from './company-registration/company-registration-entry/company-registration-entry.component';
import { CompanyRegistrationSearchComponent } from './company-registration/company-registration-search/company-registration-search.component';
import { FormsModule } from "@angular/forms";
import { ExceptionalCoefficientsComponent } from "./exceptional-coefficients/exceptional-coefficients.component";
import { ExceptionalCoefficientsListComponent } from './exceptional-coefficients/exceptional-coefficients-list/exceptional-coefficients-list.component';
import { ExceptionalCoefficientsSearchComponent } from './exceptional-coefficients/exceptional-coefficients-search/exceptional-coefficients-search.component';
import { ExceptionalCoefficientsEntryComponent } from './exceptional-coefficients/exceptional-coefficients-entry/exceptional-coefficients-entry.component';
import { CourseListSearchComponent } from './course/course-list/course-list-search/course-list-search.component';
import { CourseSelectionComponent } from './course/course-sessions-checkout/course-selection/course-selection.component';
import { TeacherSelectionComponent } from '../../components/teacher-selection/teacher-selection.component';
import { CourseSessionsComponent } from "src/app/components/course-sessions/course-sessions.component";
import { MarkManagementComponent } from './mark-management/mark-management.component';
import { MarkClassificationComponent } from './mark-management/mark-classification/mark-classification.component';
import { MarkTypeComponent } from './mark-management/mark-type/mark-type.component';
import { MarkClassificationTypeListComponent } from "./mark-management/mark-type/mark-classification-type-list/mark-classification-type-list.component";
import { MarkClassificationTypeEntryComponent } from "./mark-management/mark-type/mark-classification-type-entry/mark-classification-type-entry.component";
import { MarkTypeListComponent } from './mark-management/mark-type/mark-type-list/mark-type-list.component';
import { MarkTypeEntryComponent } from './mark-management/mark-type/mark-type-entry/mark-type-entry.component';
import { MarkClassificationListComponent } from './mark-management/mark-classification/mark-classification-list/mark-classification-list.component';
import { MarkClassificationEntryComponent } from './mark-management/mark-classification/mark-classification-entry/mark-classification-entry.component';
import { HolidayTypeComponent } from './holiday-type/holiday-type.component';
import { HolidayTypeListComponent } from './holiday-type/holiday-type-list/holiday-type-list.component';
import { HolidayTypeEmptyComponent } from "./holiday-type/holiday-type-empty/holiday-type-empty.component";
import { ChangeCourseRoomComponent } from './course/change-course-room/change-course-room.component';
import { SetEduStudentCourseComponent } from './course/set-edu-student-course/set-edu-student-course.component';
import { SetFinalDateComponent } from './course/set-final-date/set-final-date.component';
import { ToggleTerminfoComponent } from './parrent-term/toggle-terminfo/toggle-terminfo.component';
import { PrivateCoursePriceComponent } from './course/private-course-price/private-course-price.component';
import { StudentPrivateClassRequestComponent } from './student-private-class-request/student-private-class-request.component';
import { TermInfoSearchComponent } from './term-info/term-info-search/term-info-search.component';
import { SetSessionCoefficientComponent } from './exceptional-coefficients/set-session-coefficient/set-session-coefficient.component';
import { SelectTermBatchCourseComponent } from './course/select-term-batch-course/select-term-batch-course.component';
import { CourseListForMoveStudentComponent } from './course/course-list-for-move-student/course-list-for-move-student.component';
import { CourseSessionListComponent } from './course/course-session-list/course-session-list.component';
import { AddSupervisorToVirtualCourseComponent } from './course/add-supervisor-to-virtual-course/add-supervisor-to-virtual-course.component';
import { StudentTransferDetailsComponent } from "./course/student-transfer-details/student-transfer-details.component";
import { SurveyComponent } from "./survey/survey.component";
import { SurQuestionCatComponent } from "./survey/sur-question-cat/sur-question-cat.component";
import { SurQuestionListComponent } from "./survey/sur-question-list/sur-question-list.component";
import { SurQuestionEditComponent } from "./survey/sur-question-edit/sur-question-edit.component";
import { SurQuestionCatSearchComponent } from "./survey/sur-question-cat-search/sur-question-cat-search.component";
import { SurQuestionCatEditComponent } from "./survey/sur-question-cat-edit/sur-question-cat-edit.component";
import { SurQuestionCatAddComponent } from "./survey/sur-question-cat-add/sur-question-cat-add.component";
import { SurQuestionAddComponent } from "./survey/sur-question-add/sur-question-add.component";

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  decimal: ".",
  precision: 0,
  prefix: " ",
  suffix: "",
  thousands: ","
};

@NgModule({
  declarations: [
    CourseComponent,
    TermInfoComponent,
    AddCourseComponent,
    CourseListComponent,
    CourseTypeComponent,
    PackageListComponent,
    TermInfoListComponent,
    TermInfoEntryComponent,
    CoursePatternComponent,
    TimeSheetListComponent,
    AddCourseEntryComponent,
    TimeSheetEntryComponent,
    CourseTypeListComponent,
    CourseTypeEntryComponent,
    AddPackageEntryComponent,
    AddTeacherEntryComponent,
    EducationPackageComponent,
    CoursePatternListComponent,
    CoursePatternEntryComponent,
    PlacementTimeSheetComponent,
    PlacementTypeEntryComponent,
    CourseHistoryComponent,
    CourseHistoryEntryComponent,
    CourseHistoryListComponent,
    ParrentTermComponent,
    ParentTermListComponent,
    ParentTermEntryComponent,
    LevelInfoComponent,
    LevelInfoListComponent,
    LevelInfoEntryComponent,
    LevelPrerequisiteComponent,
    LevelPrerequisiteListComponent,
    LevelPrerequisiteEntryComponent,
    LevelPriceComponent,
    LevelPriceEntryComponent,
    LevelPriceListComponent,
    StaffComponent,
    StaffListComponent,
    TeacherToLvlEntryComponent,
    CourseSessionsCheckoutComponent,
    PackageEducationBranchComponent,
    AddLevelToPackageComponent,
    RegisterStudentCourseComponent,
    EditCourseEntryComponent,
    CompanyRegistrationComponent,
    CompanyRegistrationListComponent,
    CompanyRegistrationEntryComponent,
    CompanyRegistrationSearchComponent,
    ExceptionalCoefficientsComponent,
    ExceptionalCoefficientsListComponent,
    ExceptionalCoefficientsSearchComponent,
    ExceptionalCoefficientsEntryComponent,
    CourseListSearchComponent,
    CourseSelectionComponent,
    TeacherSelectionComponent,
    MarkManagementComponent,
    MarkClassificationComponent,
    MarkTypeComponent,
    MarkTypeListComponent,
    MarkTypeEntryComponent,
    MarkClassificationTypeListComponent,
    MarkClassificationTypeEntryComponent,
    MarkClassificationListComponent,
    MarkClassificationEntryComponent,
    HolidayTypeComponent,
    HolidayTypeListComponent,
    HolidayTypeEmptyComponent,
    ChangeCourseRoomComponent,
    SetEduStudentCourseComponent,
    SetFinalDateComponent,
    ToggleTerminfoComponent,
    PrivateCoursePriceComponent,
    StudentPrivateClassRequestComponent,
    TermInfoSearchComponent,
    SetSessionCoefficientComponent,
    SelectTermBatchCourseComponent,
    CourseListForMoveStudentComponent,
    CourseSessionsComponent,
    CourseSessionListComponent,
    AddSupervisorToVirtualCourseComponent,
    StudentTransferDetailsComponent,
    SurveyComponent,
    SurQuestionCatComponent,

    SurQuestionListComponent,
    SurQuestionEditComponent,
    SurQuestionCatSearchComponent,
    SurQuestionCatEditComponent,
    SurQuestionCatAddComponent,
    SurQuestionAddComponent
  ],
  imports: [sharedModule, FormsModule, CurrencyMaskModule],
  entryComponents: [
    AlertDialogComponent,
    TermInfoEntryComponent,
    TermInfoSearchComponent,
    AddCourseEntryComponent,
    TimeSheetEntryComponent,
    LevelInfoEntryComponent,
    AddTeacherEntryComponent,
    CourseTypeEntryComponent,
    CourseListSearchComponent,
    AddPackageEntryComponent,
    LevelPriceEntryComponent,
    SelectTermBatchCourseComponent,
    ParentTermEntryComponent,
    ToggleTerminfoComponent,
    PlacementTypeEntryComponent,
    CoursePatternEntryComponent,
    CourseHistoryEntryComponent,
    LevelPrerequisiteEntryComponent,
    TeacherToLvlEntryComponent,
    AddLevelToPackageComponent,
    RegisterStudentCourseComponent,
    EditCourseEntryComponent,
    SetEduStudentCourseComponent,
    SetFinalDateComponent,
    ChangeCourseRoomComponent,
    PrivateCoursePriceComponent,
    CompanyRegistrationSearchComponent,
    ExceptionalCoefficientsEntryComponent,
    SetSessionCoefficientComponent,
    ExceptionalCoefficientsSearchComponent,
    CourseSelectionComponent,
    TeacherSelectionComponent,
    CourseSessionsComponent,
    MarkTypeListComponent,
    MarkTypeEntryComponent,
    MarkClassificationTypeEntryComponent,
    MarkClassificationEntryComponent,
    HolidayTypeEmptyComponent,
    CourseListForMoveStudentComponent,
    CourseSessionListComponent,
    AddSupervisorToVirtualCourseComponent,
    StudentTransferDetailsComponent,
    SurQuestionListComponent,
    SurQuestionEditComponent,
    SurQuestionCatSearchComponent,
    SurQuestionCatEditComponent,
    SurQuestionCatAddComponent,
    SurQuestionAddComponent
  ],
  providers: [
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
  ]
})
export class InstituteModule { }
